/**
 * Password validation rules for signup and reset flows.
 * Rules: 8+ chars, at least 1 uppercase letter, at least 1 number.
 */
export function validatePassword(password) {
  const errors = []

  if (!password || password.length < 8) {
    errors.push('Must be at least 8 characters')
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Must include an uppercase letter')
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Must include a number')
  }

  return { valid: errors.length === 0, errors }
}
